import { createReducer } from '@reduxjs/toolkit'

import { DEFAULT_EXPANDED_NAV_MENU_IDS } from 'components_new/organisms/Navbar/lib'

import * as actions from '../../actions/NavigationMenu/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export type NavigationMenuStore = {
  open: boolean
  expandedItems: string[]
}

// Initial state
const INITIAL_STATE: NavigationMenuStore = {
  expandedItems: DEFAULT_EXPANDED_NAV_MENU_IDS,
  open: true
}

// Reducer
const NavigationMenuReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.toggleOpen, (state) => {
      state.open = !state.open
    })
    .addCase(actions.toggleItem, (state, action) => {
      const id = action.payload

      if (state.expandedItems.includes(id)) {
        state.expandedItems = state.expandedItems.filter(
          (folder) => folder !== id
        )
      } else {
        state.expandedItems.push(id)
      }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})

export default NavigationMenuReducer
